var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header',{on:{"click":_vm.onHeaderClick}},[_vm._t("header")],2),_c('b-collapse',{ref:"collapse",attrs:{"visible":_vm.visible}},[_c('b-card-body',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }